import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { GuiService } from 'src/app/services/gui.service';
import { RestService } from 'src/app/services/rest.service';

@Component({
  selector: 'vex-select-challenge',
  templateUrl: './select-challenge.component.html',
  styleUrls: ['./select-challenge.component.scss']
})
export class SelectChallengeComponent implements OnInit {
  category;
  subCategories = [];
  selectedChallenge = null;
  miniSpinner: boolean = false;
  data;
  showSnackBar: boolean = false;

  constructor(private router: Router, public guiService: GuiService, public translate: TranslateService, public restService: RestService) { }

  ngOnInit() {
    this.data = history.state.bannerCategory;
    if(this.data){
      this.category = JSON.parse(this.data)
      this.getTimeChallenges();
    }else{
      this.myBackButton()
    }
    this.guiService.showSpinner = false;
  }

  myBackButton() {
    this.router.navigate(['main/home']);
  }

  ionViewWillLeave(){
    this.selectedChallenge = null;
  }

  getTimeChallenges() {
    this.miniSpinner = true;
    const param = { page: 0, size: 10, filterAnd: [{ field: "parentId", operator: "eq", value: this.category.id }] };
    this.restService.postService('category', '/search?ALL_LANGUAGES=true', param).subscribe({
      next: (ris) => {
        this.subCategories = [];
        ris.items.forEach(element => {
          if (element.videos && element.videos.length > 0) {
            this.subCategories.push(element);
          }
        });
        this.miniSpinner = false;
      }, error: () => {
        this.miniSpinner = false;
      }
    })
  }

  selectChallenge(element) {
    if(!this.guiService.lastAcceptedChallenge || this.guiService.lastAcceptedChallenge.id !== element.id){
      this.selectedChallenge = element;
    }
  }

  async startChallenge() {
    if (this.selectedChallenge) {
      this.guiService.showSpinner = true;
      const challId = JSON.parse(this.category.videos[0].pdf)
      const params = { tkn: 'Bearer ' + sessionStorage.getItem('tkn'), userId: this.guiService.userLogged.user.id, selectedCategoryId: this.selectedChallenge.id, challengeId: challId[this.translate.currentLang.toUpperCase()] };
      this.restService.postService('node', '/accept-challenge', params).subscribe(async (res) => {
        console.debug(res)
        this.guiService.showSpinner = false;
        this.guiService.lastAcceptedChallenge = this.selectedChallenge;
        console.debug('lastAcceptedChallenge', this.guiService.lastAcceptedChallenge);
        console.debug('SELECTED_CHALL', this.selectedChallenge)
        // const toast = await this.toastController.create({
        //   message: this.translate.instant('BANNER_CHALLENGE.CHALL_ACCEPTED'),
        //   duration: 3000,
        //   cssClass: 'chall-toast',
        //   position: 'middle',
        // });
        // await toast.present();
        this.showSnackBar = true;
        setTimeout(() => {
          this.showSnackBar = false;
        }, 3000);

        this.selectedChallenge = null;

        setTimeout(() => {
          this.router.navigate(['main/home'])
        }, 3000);
      })
    }
  }

}
